"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypesApi = exports.UserProductTypeOperationCode = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var UserProductTypeOperationCode;
(function (UserProductTypeOperationCode) {
    UserProductTypeOperationCode["Delete"] = "delete";
})(UserProductTypeOperationCode = exports.UserProductTypeOperationCode || (exports.UserProductTypeOperationCode = {}));
function ProductTypesApiAxiosParamCreator(configuration) {
    return {
        getUserProductType(productTypeId, marketId, options = {}) {
            if (productTypeId === null || productTypeId === undefined) {
                throw new base_1.RequiredError("productTypeId", "Required parameter productTypeId was null or undefined when calling getUserProductType.");
            }
            const localVarPath = `/account/product-types/{productTypeId}`.replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (marketId !== undefined) {
                localVarQueryParameter["marketId"] = marketId;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserProductTypes(options = {}) {
            const localVarPath = `/account/product-types`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        insertUserProductType(LightUserProductType, options = {}) {
            if (LightUserProductType === null || LightUserProductType === undefined) {
                throw new base_1.RequiredError("LightUserProductType", "Required parameter LightUserProductType was null or undefined when calling insertUserProductType.");
            }
            const localVarPath = `/account/product-types`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof LightUserProductType !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(LightUserProductType !== undefined ? LightUserProductType : {})
                : LightUserProductType || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        patchUserProductTypes(UserProductTypeOperation, options = {}) {
            if (UserProductTypeOperation === null ||
                UserProductTypeOperation === undefined) {
                throw new base_1.RequiredError("UserProductTypeOperation", "Required parameter UserProductTypeOperation was null or undefined when calling patchUserProductTypes.");
            }
            const localVarPath = `/account/product-types`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PATCH" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof UserProductTypeOperation !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(UserProductTypeOperation !== undefined
                    ? UserProductTypeOperation
                    : {})
                : UserProductTypeOperation || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        reorderUserProductTypes(IDWithPriority, options = {}) {
            if (IDWithPriority === null || IDWithPriority === undefined) {
                throw new base_1.RequiredError("IDWithPriority", "Required parameter IDWithPriority was null or undefined when calling reorderUserProductTypes.");
            }
            const localVarPath = `/account/product-types`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "PUT" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "application/json";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof IDWithPriority !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(IDWithPriority !== undefined ? IDWithPriority : {})
                : IDWithPriority || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function ProductTypesApiFp(configuration) {
    return {
        getUserProductType(productTypeId, marketId, options) {
            const localVarAxiosArgs = ProductTypesApiAxiosParamCreator(configuration).getUserProductType(productTypeId, marketId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getUserProductTypes(options) {
            const localVarAxiosArgs = ProductTypesApiAxiosParamCreator(configuration).getUserProductTypes(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        insertUserProductType(LightUserProductType, options) {
            const localVarAxiosArgs = ProductTypesApiAxiosParamCreator(configuration).insertUserProductType(LightUserProductType, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        patchUserProductTypes(UserProductTypeOperation, options) {
            const localVarAxiosArgs = ProductTypesApiAxiosParamCreator(configuration).patchUserProductTypes(UserProductTypeOperation, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        reorderUserProductTypes(IDWithPriority, options) {
            const localVarAxiosArgs = ProductTypesApiAxiosParamCreator(configuration).reorderUserProductTypes(IDWithPriority, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class ProductTypesApi extends base_1.BaseAPI {
    getUserProductType(productTypeId, marketId, options) {
        return ProductTypesApiFp(this.configuration).getUserProductType(productTypeId, marketId, options)(this.axios, this.basePath);
    }
    getUserProductTypes(options) {
        return ProductTypesApiFp(this.configuration).getUserProductTypes(options)(this.axios, this.basePath);
    }
    insertUserProductType(LightUserProductType, options) {
        return ProductTypesApiFp(this.configuration).insertUserProductType(LightUserProductType, options)(this.axios, this.basePath);
    }
    reorderUserProductTypes(IDWithPriority, options) {
        return ProductTypesApiFp(this.configuration).reorderUserProductTypes(IDWithPriority, options)(this.axios, this.basePath);
    }
    patchUserProductTypes(UserProductTypeOperation, options) {
        return ProductTypesApiFp(this.configuration).patchUserProductTypes(UserProductTypeOperation, options)(this.axios, this.basePath);
    }
}
exports.ProductTypesApi = ProductTypesApi;
